import { lazy } from "react";
import { promiseRetry } from "./promise-retry.js";
function lazyWithRetry(factory) {
  return lazy(() => promiseRetry(factory));
}
export {
  lazyWithRetry
};
